import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import _uniqueId from 'lodash/uniqueId';

import { buttonStyle } from '../Button';
import uploadFile, { UploadFileResponse } from './uploader';

import iconFile from '../../assets/icons//file.svg';
import iconLoading from '../../assets/icons/loading-alt.svg';
import iconSuccess from '../../assets/icons/check-circle.svg';
import iconError from '../../assets/icons/times-circle.svg';

const StyledComponent = styled.div`
    padding: 12px;
    background-color: hsl(0, 0%, 98%);
    border: 1px solid hsl(0, 0%, 95%);
    border-radius: var(--base-border-radius);
    display: flex;
    &.compact {
        padding: 0;
        background-color: transparent;
        border: none;
        flex-direction: column;
        .btn {
            width: 100%;
        }
        .status {
            padding: 8px;
            padding-left: inherit;
            margin-top: 4px;
            background-color: hsl(0, 0%, 98%);
            border: 1px solid hsl(0, 0%, 95%);
            border-radius: var(--base-border-radius);
            .label {
                font-size: 14px;
            }
        }
    }
    .status {
        padding-left: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        .label {
            font-size: 1.2rem;
            text-align: center;
        }
        .icon {
            margin-left: 8px;
            width: 14px;
            height: 14px;
        }
        &--uploading {
            color: var(--color-gray-dark);
            .icon {
                opacity: .85;
                width: 32px;
                height: 32px;
            }
        }
        &--uploaded {
            color: var(--color-success);
            .icon {
                filter: var(--filter-success);
            }
        }
        &--error {
            color: var(--color-danger);
            .icon {
                filter: var(--filter-danger);
            }
        }
    }
    .btn {
        ${buttonStyle}
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content;
        .icon {
            margin-right: 14px;
            width: 22px;
            height: 22px;
            filter: var(--filter-white);
        }
    }
    input {
        display: none !important;
    }
`

interface props{
    name: string;
    label: string;
    icon?: string;
    variant?: string;
    accept?:string
}

const Component = React.forwardRef((props:props, ref) => {
    const [state, setState] = useState('idle');
    const [file, setFile] = useState(undefined);
    const [uploadStatus, setUploadStatus] = useState(undefined);
    const [fieldId] = useState(_uniqueId('file-input-'));

    const targetInput = useRef();

    useEffect(() => {
        if (uploadStatus) {
            targetInput.current.querySelector('.targetInput').value = uploadStatus.key;
        }
    }, [uploadStatus])

    useEffect(() => {
        if (file) {
            handleFileUpload(file);
        }
    }, [file])

    const handleFileUpload = async (file:File)=> {
        setState('uploading');
        uploadFile(file).then(r => {
            setUploadStatus(r);
            setState('uploaded');
        }).catch( e => {
            setFile(undefined);
            setState('error');
        });
    }

    const handleInputChange = (e) => {
        const inputFile = e.target.files[0];
        if (inputFile) {
            console.log('Ilde');
            setState('idle');
            setUploadStatus(undefined);

            setFile(inputFile);
        }
    }

    return (
        <StyledComponent className={'file-upload--' + state + (props.variant? (' ' + props.variant) : '')}>
            <label htmlFor={fieldId} ref={targetInput}>
                <div className="btn">
                    <div className="icon"><img src={props.icon ? props.icon : iconFile}/></div>
                    <div className="label">{props.label}</div>
                </div>
                <input id={fieldId} type="file" onChange={(e) => handleInputChange(e)}/>
                <input className="targetInput" type="text" name={props.name} ref={ref} accept={props.accept}/>
            </label>
            {
                state === 'uploading' &&
                <div className="status status--uploading">
                    <div className="label">Cargando archivo </div>
                    <div className="icon"><img src={iconLoading} alt="Cargando"/></div>
                </div>
            }
            {
                state === 'uploaded' &&
                <div className="status status--uploaded">
                    <div className="label">El archivo se cargó exitosamente</div>
                    <div className="icon"><img src={iconSuccess}/></div>
                </div>
            }
            {
                state === 'error' &&
                <div className="status status--error">
                    <div className="label">Ocurrió un error al intentar subir el archivo. Intente nuevamente.</div>
                    <div className="icon"><img src={iconError}/></div>
                </div>
            }
        </StyledComponent>
    )
});

export default Component;
